import React from 'react';
import { Button } from 'primereact/button';

const TableRow = ({el, order, handleAssignment}) => {

    return (
        <tr>
            <th scope="row">{++order}:{el.solicitudid}</th>
            <td>{el.solicitante}</td>
            <td>{el.validador}</td>
            <td>{el.fecha_asignacion}</td>
            <td>{el.institucion_educativa}</td>
            <td>{el.titulo}</td>
            <td>{el.correo_electronico}</td>
            <td>{el.telefono}</td>
            <td>
                <Button type="button" label="Reasignación" icon="pi pi-share-alt" onClick={() => handleAssignment(el.solicitudid)} />
            </td>
        </tr>
    );  
}

export default TableRow;